import React from 'react';
import {
  Dialog, Grid, Typography, Box, 
  Divider, Stack, IconButton 
} from '@mui/material';
import styles from '../../../custom/style.module.css';
import { CustomDialogTitle, CustomDialogContent, CustomTextField, CustomButton, StyledCard, CustomInputLabel, InputProps, } from '../../../custom/components';
import { CancelIcon, CloseIconBtn } from '../../../custom/constants';
import docStyles from './anydoc.module.css';

const AddManualInputModal = (props) => {

  return (
    <Dialog aria-labelledby='form-dialog-title' open={props.modal === 'manual_input'} onClose={props.onClose}>
      <CustomDialogTitle id='form-dialog-title' className={styles.modalTitle}>
        Add New Field
        <CloseIconBtn onClick={props.onClose} />
      </CustomDialogTitle>
      <Box component='form' className={styles.w100}>
        <CustomDialogContent>
          <Typography variant='body2' sx={{
            mb: 2,
            color: '#6B7280',
            backgroundColor: '#F3F4F6',
            p: 2,
            borderRadius: 1,
            border: '1px solid #E5E7EB', 
            fontSize: '0.7rem'
          }}>
           Manually added labels with reference values will be used to extract relevant information from documents. 
           These labels will be used to input any additional information that may not be captured through automated means, 
           providing flexibility in document management.
          </Typography>
          <StyledCard>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <CustomInputLabel htmlFor='' required>Label Name</CustomInputLabel>
                <CustomTextField
                  {...InputProps}
                  fullWidth
                  id=''
                  name='label'
                  placeholder='Eg: Flight Number'
                  type='text'
                  required
                  autoFocus
                  value={props.manualInput.label}
                  onChange={props.handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <CustomInputLabel htmlFor=''>Reference Value</CustomInputLabel>
                <CustomTextField
                  {...InputProps}
                  fullWidth
                  id=''
                  name='value'
                  placeholder='Eg: TX-12345'
                  type='text'
                  value={props.manualInput.value}
                  onChange={props.handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <CustomInputLabel htmlFor=''>Notes</CustomInputLabel>
                <CustomTextField
                  {...InputProps}
                  fullWidth
                  multiline
                  id=''
                  name='notes'
                  placeholder='Add notes or description to describe how the valueis calculated'
                  type='text'
                  rows={4}
                  maxRows={5}
                  value={props.manualInput.notes}
                  onChange={props.handleInputChange}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                <CustomButton variant='contained' fullWidth onClick={props.handleAddField}>
                    Add Values
                </CustomButton>
              </Grid>
            </Grid>
          </StyledCard>
          {/* Section for already added fields */}
          <Divider sx={{
            width: '100%',
            my: 2 
          }} />
          <Box sx={{ mt: 2 }}>
            <Typography variant='body2' sx={{ mb: 2 }} fontWeight={500} color='primary'>
                Manually added labels with reference data.
            </Typography>
            {Object.keys(props.addedFields || {}).length === 0 ? (
              <Typography variant='body2' color='text.secondary'>No fields added yet.</Typography>
            ) : (
              <Grid container spacing={2}>
                {Object.entries(props.addedFields || {}).map(([key, field], idx) => (
                  <Grid item xs='auto' key={idx} className={docStyles.manualFieldItem}>
                    <Stack direction='row' spacing={1.5} className={docStyles.manualFieldStack}>
                      <Typography variant='caption' fontWeight={500} color='primary'>{key} :</Typography>
                      <Typography variant='caption' color='text.secondary'>{field}</Typography>
                    </Stack>
                    <IconButton className={docStyles.cancelIcon} onClick={() => props.handleRemoveField(key)}>
                      <CancelIcon />
                    </IconButton>
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>
        </CustomDialogContent>
      </Box>
    </Dialog>
  );
};

export default AddManualInputModal;